var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrazilLuckyDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 423332 423332",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    shapeRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201847.3 221483.8v123455.7c-3899 18183.3-17364.5 32809-35160.5 38198s-37119.8 690.8-50452.5-12274.3c-13332.7-12958.5-18575.5-32136.3-13687-50078.4-17942 4888.4-37119.8-354.4-50078.4-13687-12965-13332.7-17663-32656.4-12274.3-50452.5s20014.6-31261.6 38198-35161.3h123454.8z",
    fill: "#D28891"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221484.5 221483.8h123455.7c18182.5 3899 32808.2 17364.5 38197 35160.5s691.7 37119.8-12273.4 50452.5c-12958.5 13332.7-32137 18575.5-50078.4 13688 4887.6 17941.3-355.3 37119.8-13688 50078.4-13332.7 12965-32656.4 17662.3-50452.5 12273.4s-31261.6-20014.6-35160.5-38197V221483.8z",
    fill: "#BF194E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221483.7 201847.5V78391.8c3899-18182.5 17364.5-32808.2 35160.5-38197s37119.8-691.7 50452.5 12273.4c13332.7 12958.5 18575.5 32137 13688 50078.4 17941.3-4887.6 37119.8 355.3 50078.4 13688 12964.3 13332.7 17662.3 32656.4 12273.4 50452.5s-20014.6 31261.6-38197 35160.5H221483.7z",
    fill: "#D28891"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201848.2 201847.5H78392.5c-18182.5-3899-32809-17364.5-38198-35160.5s-690.8-37119.8 12274.3-50452.5c12958.5-13332.7 32136.3-18575.5 50078.4-13687-4888.4-17942 355.3-37119.8 13688-50078.4 13332.7-12965 32656.4-17663 50451.7-12274.3 17796 5389 31262.5 20014.6 35161.3 38198v123454.8z",
    fill: "#BF194E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazilLuckyDay);
export default __webpack_public_path__ + "static/media/brazil_lucky_day.0d6770efd3c52f223b1ead659e143c9f.svg";
export { ForwardRef as ReactComponent };